import { ParserPhase } from "../../text/lexer/parsing/ParserPhase";
import { RJParser } from "../RJParser";

export class RJValidateTokens extends ParserPhase<RJParser>
{
  static readonly phaseInfo = "RJ Validate Tokens";
  get phaseInfo(){ return RJValidateTokens.phaseInfo; }

  process()
  {

  }
}